import { useState, useEffect, useRef } from 'react'

/**
 * useReveal — triggers a CSS 'in' class when the element
 * enters the viewport. Fires once and disconnects.
 */
export function useReveal(threshold = 0.1) {
  const [vis, setVis] = useState(false)
  const ref = useRef()
  useEffect(() => {
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); io.disconnect() } },
      { threshold }
    )
    if (ref.current) io.observe(ref.current)
    return () => io.disconnect()
  }, [threshold])
  return [ref, vis]
}
